/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: CZK
 * @Date: 2025-06-13 15:14:48
 * @LastEditors: CZK
 * @LastEditTime: 2026-07-01 14:06:47
 */
import Vue from 'vue';
import 'animate.css'; // 引入动画库

Vue.directive('appear-animation', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // el.classList.add(binding.value); // 添加动画类名
          // observer.unobserve(el); // 停止观察
        }
      });
    }, {
      rootMargin: '0px', // 视口边缘触发条件
      threshold: 0.01 // 可见比例阈值（0.1表示10%可见即触发）
    });
    observer.observe(el);
  },
  unbind(el) {
    el.classList.remove('animate__animated'); // 清除动画类名
  }
});




Vue.directive('lazy', {
  inserted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.src = binding.value; // 替换为真实地址
          observer.unobserve(el); // 停止监听
        }
      });
    }, {
      rootMargin: '0px', // 视口边缘触发条件
      threshold: 0.01 // 可见比例阈值（0.1表示10%可见即触发）
    });
    observer.observe(el);
  }
});


Vue.directive('lazy-bg', {
  inserted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.style.backgroundImage = `url(${binding.value})`;
          observer.unobserve(el); // 停止监听
        }
      });
    }, {
      rootMargin: '0px', // 视口边缘触发条件
      threshold: 0.01 // 可见比例阈值（0.1表示10%可见即触发）
    });
    observer.observe(el);
  }
});